import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Re-align a few times since late embeds (e.g. Stripe table) shift layout; stop once the user scrolls.
      let userMoved = false;
      const stop = () => { userMoved = true; };
      window.addEventListener('wheel', stop, { passive: true });
      window.addEventListener('touchmove', stop, { passive: true });
      const timers = [120, 700, 1500, 2600].map((ms) => setTimeout(() => {
        if (!userMoved) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: ms === 120 ? 'smooth' : 'auto' });
      }, ms));
      return () => {
        timers.forEach(clearTimeout);
        window.removeEventListener('wheel', stop);
        window.removeEventListener('touchmove', stop);
      };
    }
    return undefined;
  }, [pathname, hash]);

  // Jump (not smooth-scroll) to top before paint so mobile browsers never land mid-page.
  useLayoutEffect(() => {
    if (hash) return;
    // 'instant' overrides the global CSS `scroll-behavior: smooth` (an inline style swap is not applied without a style flush).
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
}
